import { useTranslation } from 'react-i18next';
import {
  Box, Typography, Button, Link
} from '@mui/material';

const NotFound = ({ isLoggedIn }) => {
  const { t } = useTranslation();

  return (
    <Box color="white">
      <Typography color="white" textTransform="uppercase" variant="h1" mb={4}>{t('pageNotFoundTitle')}</Typography>
      <Typography variant="h6" color="white" my={2}>{t('pageNotFoundDescription')}:</Typography>
      <Typography display="flex" alignItems="center" variant="h6" my={1}>
        <Box component="span" mx={1}>&bull;</Box> {t('pageNotFoundReasons.0')}
      </Typography>
      <Typography display="flex" alignItems="center" variant="h6" my={1}>
        <Box component="span" mx={1}>&bull;</Box> {t('pageNotFoundReasons.1')}
      </Typography>
      <Typography display="flex" alignItems="center" variant="h6" my={1}>
        <Box component="span" mx={1}>&bull;</Box> {t('pageNotFoundReasons.2')}
      </Typography>
      <Typography display="flex" alignItems="center" variant="h6" my={1} mb={5}>
        <Box component="span" mx={1}>&bull;</Box> {t('pageNotFoundReasons.3')}
      </Typography>
      <Button
        color="light"
        component={Link}
        size="large"
        fullWidth
        href="/"
        sx={{ fontWeight: 600, maxWidth: 450 }}
      >
        {t(isLoggedIn ? 'backToStatsPage' : 'backToHomePage')}
      </Button>
    </Box>
  );
};

export default NotFound;
